import { useTranslation } from 'react-i18next';

import { DashboardProjectCardHeaderContent } from '@/features/dashboard/components/dashboard/dashboard-project-card-header-content';
import { BaseProjectSlideCardProps } from '@/features/dashboard/components/dashboard/dashboard-project-slot-card';
import { EmptyTablePlaceholderContent } from '@/shared/components/table/empty-table-placeholder';
import { Card, CardContent, CardHeader } from '@/shared/components/ui/card';

export const NoAnomaliesProjectCard = ({
  project,
  currentCardIndex,
  onCardIndexChange,
  isPaused,
  onTogglePause,
}: BaseProjectSlideCardProps) => {
  const { t } = useTranslation('overview', {
    keyPrefix: 'OverviewPage',
  });

  return (
    <Card variant="informationAlt" className="size-full p-0">
      <CardHeader className="flex flex-row items-start justify-between px-6 pt-6">
        <DashboardProjectCardHeaderContent
          kpiName={t('kpiCards.anomalies')}
          projectName={project.name}
          currentPageIndex={currentCardIndex}
          onCardIndexChange={onCardIndexChange}
          isPaused={isPaused}
          onTogglePause={onTogglePause}
        />
      </CardHeader>
      <CardContent className="flex h-full items-center justify-center px-7">
        <EmptyTablePlaceholderContent
          className="w-full p-0"
          title={t('emptyAnomaliesProjectCard.title')}
          description={t('emptyAnomaliesProjectCard.description')}
          centered
        />
      </CardContent>
    </Card>
  );
};
